import { makeStyles } from "@material-ui/core/styles";

export function useUsersDetailsTabsStyles() {
  const useStyles = makeStyles((theme) => ({
    tabRoot: {
      minHeight: 0,
      "& .MuiTab-wrapper": {
        flexDirection: "row",
        gap: theme.spacing(1),
      },
    },
    tabPanelContent: {
      padding: theme.spacing(2),
    },
  }));

  const classes = useStyles();

  return {
    classes,
  };
}
